import { useEffect, useState } from 'react';
import { taskTemplatesApi } from '@/lib/api/taskTemplates';
import { toolsApi } from '@/lib/api/tools';

// Public catalog reads only. Never schedule a task, run a tool, or search Maps.
export default function useDiscoveryCatalog({ enabled, contextKey }) {
  const [state, setState] = useState({ key: contextKey, tasks: [], tools: [] });
  useEffect(() => {
    let active = true;
    setState({ key: contextKey, tasks: [], tools: [] });
    if (enabled) {
      taskTemplatesApi.fetchTemplates().then(result => {
        if (active) setState(previous => ({ ...previous, tasks: (result.templates || []).filter(item => item.slug)
          .sort((a, b) => Number(!!b.flags?.isFeatured) - Number(!!a.flags?.isFeatured)).slice(0, 18) }));
      }).catch(() => {});
      toolsApi.list({ limit: 18 }).then(result => {
        if (active) setState(previous => ({ ...previous, tools: (result.tools || result.data?.tools || []).filter(item => item.slug).slice(0, 18) }));
      }).catch(() => {});
    }
    return () => { active = false; };
  }, [enabled, contextKey]);
  return state.key === contextKey ? state : { tasks: [], tools: [] };
}
